import { exists, filterDuplicates, filterInstances, MUSTNeverHappenException } from '@nu-art/ts-common';
import { schemaConversion } from '@app/hcs-shared/expression/index';
import { ModuleFE_Variable } from '../../../_entity/variable/index.js';
import { ModuleFE_Value } from '../../../_entity/value/index.js';
import { ModuleFE_Expression } from '../../../_entity/expression/index.js';
import { valueID_No, valueID_Yes, valueType_StandardRange } from '@app/hcs-shared';
/**
 * Converts a database expression to the json schema representation.
 * @param expression - The database expression to be converted.
 * @returns The AI team schema of the expression.
 */
export const convertExpressionToSchemaFE = (expression) => {
    const expressionDependencies = collectDependenciesFE(expression._refs);
    return schemaConversion(expression, expressionDependencies);
};
/**
 * Gets a collection mapper for a specific module API.
 * @param module - The frontend module API.
 * @returns A function that maps an ID to the corresponding entity in the module's cache.
 */
const getCollectionMapperFE = (module) => {
    return (id) => {
        const entity = module.cache.unique(id);
        if (!entity)
            throw new MUSTNeverHappenException(`${module.dbDef.entityName} with id ${id} not found!`);
        return entity;
    };
};
// /**TODO: Remove when possible
//  * Gets an array of SNOMED references associated with the given variables.
//  * @param variables - An array of database variables.
//  * @returns An array of SNOMED references related to the provided variables.
//  */
// const getVariableSnomedRefs = (variables: DB_Variable[]) => {
// 	return variables.map(_variable => {
// 		return ModuleFE_Reference.cache.filter(ref => _variable.referenceIds.includes(ref._id) && ref.type === 'snomed');
// 	}).flat();
// };
const getDefaultYesNo = () => {
    const defaultValues = ModuleFE_Value.cache.filter(value => value._id === valueID_No || value._id === valueID_Yes);
    if (defaultValues.some(value => !exists(value)))
        throw new MUSTNeverHappenException('yes/no value is missing!');
    return filterInstances(defaultValues);
};
const collectNormalRangeExpressions = (variables) => {
    return filterInstances(variables.map(_variable => {
        const value = ModuleFE_Value.cache.unique(_variable.valueId);
        if (!value)
            return;
        if (value.type === valueType_StandardRange)
            return ModuleFE_Expression.cache.find(expr => expr.associatedVar === _variable._id);
    }));
};
/**
 * Collects dependencies from a refs object.
 * @param refs - The references object containing variable, value, and expression IDs.
 * @returns The collected dependencies.
 */
const collectDependenciesFE = (refs) => {
    const dependencies = {};
    // Collect variables
    dependencies.variables = refs._variableIds.map(getCollectionMapperFE(ModuleFE_Variable));
    // Collect values
    dependencies.values = filterDuplicates([...refs._valueIds.map(getCollectionMapperFE(ModuleFE_Value)), ...getDefaultYesNo()], item => item._id);
    // Collect expressions
    dependencies.expressions = filterDuplicates([...collectNormalRangeExpressions(dependencies.variables), ...refs._exprIds.map(getCollectionMapperFE(ModuleFE_Expression))], item => item._id);
    return dependencies;
};
//# sourceMappingURL=convertExpressionToSchemaFE.js.map